import React from 'react';
import { Global } from '@mantine/core';
import createShades from 'colorshades';

import * as components from './components/components';
import { MantineTheme } from '@mantine/core';

export const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1400,
};

export const typography = {
  global: {
    fontFamily: 'Metropolis, sans-serif',
    fontStyle: 'normal',
  },
};
export const shades = (hex) =>
  createShades(hex).colors.map((x) => x.toString());

export const theme = {
  ...typography.global,
  globalStyles: (_t) => ({
    '*, *::before, *::after': {
      boxSizing: 'border-box',
    },
  }),
  headings: {
    fontFamily: 'Metropolis, sans-serif',
    fontWeight: 'bold',
  },
  colors: {
    primary: shades('#002462'),
    secondary: shades('#CF181B'),
    accentSubtle: shades('#ECEEFE'),
    fgMuted: shades('#636A77'),
    success: shades('#11763D'),
    warning: shades('#FFBB38'),
    default: shades('#171717'),
  },
  primaryColor: 'primary',
  primaryShade: 8,
  other: {
    typography,
  },
  components,
  breakpoints,
};

export type MantineThemeType = typeof theme & MantineTheme;
export const GlobalStyles = () => {
  return <Global styles={{}} />;
};
